import { Text } from "@chakra-ui/react";

function Heading({
    headingText,
    subheadText,
}: {
    headingText: string,
    subheadText?: string
}) {
    return(
        <>
            <Text fontSize="34px" lineHeight="60px" fontWeight="bold">{ headingText }</Text>
            { subheadText ? <Text fontSize="14px" lineHeight="21px" marginTop="20px">{ subheadText }</Text> : null}            
        </>        
    )
}

export default Heading